import { render } from "./Movimenti.vue?vue&type=template&id=621e53f4&scoped=true&ts=true"
import script from "./Movimenti.vue?vue&type=script&lang=ts"
export * from "./Movimenti.vue?vue&type=script&lang=ts"

import "./Movimenti.vue?vue&type=style&index=0&id=621e53f4&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_jecko_1764366014063414604/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621e53f4"]])

export default __exports__